const isNil = (v: unknown): boolean => v === undefined || v === null;

export enum LOCAL_STORAGE_KEY {
  PREFILTER_DESTINATION_AIRPORT = 'prefilter_destination_airport',
}

export const getLocalStorage = (key: LOCAL_STORAGE_KEY): string | undefined => {
  const value = window?.localStorage?.getItem(key) || undefined;
  return isNil(value) ? undefined : value;
};

export const setLocalStorage = (key: LOCAL_STORAGE_KEY, value: string): void => {
  window?.localStorage?.setItem(key, value);
};

export const removeLocalStorage = (key: LOCAL_STORAGE_KEY) => {
  window?.localStorage?.removeItem(key);
};

export const getLocalStorageObject = (key: LOCAL_STORAGE_KEY) => JSON.parse(getLocalStorage(key) || '{}');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setLocalStorageObject = (key: LOCAL_STORAGE_KEY, value: any): void => {
  setLocalStorage(key, JSON.stringify(value));
};

export const localStorageExists = (key: LOCAL_STORAGE_KEY): boolean => !!getLocalStorage(key);
